import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';
import './Footer.css';

// Custom SVG components for Social Brands (Since Lucide removed them)
const FacebookIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
);

const InstagramIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

const TikTokIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        
        {/* Navigation Links */}
        <div className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          <Link to="/careers">Careers</Link>
          <Link to="/contact">Contact</Link>
          {/* <Link to="/privacy">Privacy Policy</Link> */}
        </div>

        {/* Social Media Links */}
        <div className="footer-socials">
          <a href="https://www.facebook.com/singularitytech" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FacebookIcon size={20} />
          </a>
          <a href="https://www.instagram.com/s1ngular1tytech/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <InstagramIcon size={20} />
          </a>
          <a href="https://www.tiktok.com/@s1ngular1ty_tech?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
            <TikTokIcon size={20} />
          </a>
        </div>

        {/* Contact Grid */}
        <div className="footer-grid">
          <div className="footer-col">
            <MapPin className="footer-icon" size={32} />
            <h4>Pretoria Office</h4>
            <a href="https://www.google.com/maps/search/?api=1&query=1177+Park+Street,+211+The+Lofts,+Hatfield,+0083" target="_blank" rel="noopener noreferrer">
              1177 Park Street, 211 The<br/>Lofts, Hatfield, 0083
            </a>
          </div>
          
          <div className="footer-col">
            <MapPin className="footer-icon" size={32} />
            <h4>Polokwane Office</h4>
            <a href="https://www.google.com/maps/search/?api=1&query=11+Pierre+Street,+IT+Park,+Bendor+Park,+Polokwane+0699" target="_blank" rel="noopener noreferrer">
              11 Pierre Street, IT Park, Bendor<br/>Park, Polokwane 0699
            </a>
          </div>
          
          <div className="footer-col">
            <Mail className="footer-icon" size={32} />
            <h4>Our Mailbox</h4>
            <a href="mailto:support@singularitytech.co.za">support@singularitytech.co.za</a>
            <a href="mailto:info@singularitytech.co.za">info@singularitytech.co.za</a>
            
          </div>
          
          <div className="footer-col">
            <Phone className="footer-icon" size={32} />
            <h4>Our Phone</h4>
            <a href="tel:+27158802125">+27 (015) 880 2125</a>
            <a href="tel:+27663769466">+27 66 376 9466</a>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>Copyright ©{new Date().getFullYear()} Singularity Tech. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}